export const ACCEPTED_FILE_TYPES = ".pdf,.pptx,.jpg,.jpeg,.png,.txt,.csv,.xlsx,.xls,.xlsm,.docx";
export const MAX_FILES = 20;
export const MAX_TOTAL_SIZE_BYTES = 100 * 1024 * 1024; // 100MB
